<app-throw-lines 
  *ngIf="showThrowLines" 
  (close)="onThrowLinesClosed()" 
  (startTrip)="onStartTrip($event)">
</app-throw-lines>

<app-active-trip
  *ngIf="isTripActive"
  [tripId]="currentTripId"
  [startTimeMs]="tripStartTimeMs"
  (viewDetails)="onViewDetails()"
  (openVisibilitySettings)="onOpenVisibilitySettings()"
  (inviteMate)="onOpenInviteMate()"
  (tripEnded)="onTripEnded()">
</app-active-trip>

<app-invite-a-mate
  *ngIf="showInviteMate"
  [tripId]="currentTripId"
  (close)="onInviteMateClosed()">
</app-invite-a-mate>

<app-trip-details 
  *ngIf="showTripDetails" 
  (close)="onDetailsClosed()">
</app-trip-details>

<app-visibility-settings
  *ngIf="showVisibilitySettings"
  [tripId]="currentTripId"
  (close)="onVisibilitySettingsClosed()"
  (update)="onVisibilitySettingsClosed()">
</app-visibility-settings>
